var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input"},[_c('Icon',{staticClass:"icon",attrs:{"name":"magnifier","size":"24"}}),_c('input',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }